import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
type ContainerProps = {
  handleChange: (berthId: string) => void;
};
export const useContainer = t0 => {
  const $ = _c(6);
  const {
    handleChange
  } = t0;
  const [open, setOpen] = useState(false);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      setOpen(true);
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const onClickSelectBox = t1;
  let t2;
  if ($[1] !== handleChange) {
    t2 = berthId => {
      setOpen(false);
      handleChange(berthId);
    };
    $[1] = handleChange;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const onClickBerth = t2;
  let t3;
  if ($[3] !== onClickBerth || $[4] !== open) {
    t3 = {
      open,
      onClickSelectBox,
      onClickBerth
    };
    $[3] = onClickBerth;
    $[4] = open;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
};